<template>
  <div class="footer column" v-if="isVind">
    <div class="footer-top-section row">
      <div class="footer-top-links-l column">
        <div class="row">
          <a
            class="info-top"
            href="https://www.vindsubsidies.nl/contact/"
            target="_blank"
            >Contact</a
          >
        </div>
        <a
          class="info-top row"
          href="https://www.vindsubsidies.nl/over-ons/"
          target="_blank"
          >Over ons</a
        >
        <a
          class="info-top row"
          href="https://www.vindsubsidies.nl/algemene-voorwaarden/"
          target="_blank"
          >Algemene voorwaarden</a
        >
        <a
          class="info-top row"
          href="https://www.vindsubsidies.nl/faq-database/"
          target="_blank"
        >
          FAQ - Database
        </a>
      </div>
      <div class="footer-top-links-m">
        <span class="info-top q-ml-md">088 - 2020 401</span>
      </div>
      <div class="row footer-top-links-r">
        <a
          class="info-links"
          href="https://twitter.com/vindsubsidies"
          target="_blank"
        >
          <i class="lab la-2x la-twitter"></i>
        </a>
        <a
          class="info-links"
          href="https://www.facebook.com/vindsubsidies/"
          target="_blank"
        >
          <i class="lab la-2x la-facebook-f"></i>
        </a>
        <a
          class="info-links"
          href="https://www.linkedin.com/company/vindsubsidies-nl/mycompany/"
          target="_blank"
        >
          <i class="lab la-2x la-linkedin-in"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store/index.js';
import { computed } from 'vue';
export default {
  setup() {    
    const isVind = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40
    });
    return {
      isVind
    };
  }
};
</script>
